import { combineEpics } from "redux-observable";
import { interval } from "rxjs";
import { delay, filter, map, mapTo, merge, mergeMap } from "rxjs/operators";

import { actionCreators } from "../actions";
import { isLoading } from "../reducers/config";
import { Epic } from "../utils/types";

// helpers

const fetchIndexHTML = async (url: string) => {
    const res = await window.fetch(url);
    if (res.status === 200) {
        const bodyHTML = await res.text();
        const appMatch = bodyHTML.match('APP_VERSION":"([^"]*)"');
        const electronMatch = bodyHTML.match('ELECTRON_APP_VERSION":"([^"]*)"');

        const appVersion = appMatch && appMatch[1];
        const electronVersion = electronMatch && electronMatch[1];
        if (appVersion && electronVersion) {
            return {
                APP_VERSION: appVersion,
                ELECTRON_APP_VERSION: electronVersion,
            };
        }
    }
    return;
};

// epics

const onLoad: Epic = (action$, state$) =>
    action$.ofType(actionCreators.loadConfigRequested.type).pipe(
        filter(() => !isLoading(state$.value)),
        mapTo(actionCreators.loadConfigStarted())
    );

const ajax: Epic = action$ =>
    action$.ofType(actionCreators.loadConfigStarted.type).pipe(
        mergeMap(() => fetchIndexHTML(window.location.href).catch(() => undefined)),
        map(config => {
            if (config) {
                return actionCreators.loadConfigSuccess(config);
            } else {
                return actionCreators.loadConfigFailed();
            }
        })
    );

const min = 60 * 1000;

const onSync: Epic = action$ =>
    action$.ofType(actionCreators.onOnline.type).pipe(
        merge(interval(10 * min)),
        delay((1 + Math.random()) * min),
        map(actionCreators.loadConfigRequested)
    );

export const configEpic = combineEpics(onLoad, ajax, onSync);
